import { useNavigate } from 'react-router-dom';
import { SVGAssets } from '@business/assets/vectors';
import { Button } from '../Button';

export const HeadingWithBack: React.FC<{
  title: string;
  subtitle?: string;
}> = ({ title, subtitle }) => {
  const navigate = useNavigate();

  return (
    <Button
      btnStyle="link"
      className="flex gap-3 items-center"
      onClick={() => {
        navigate(-1);
      }}>
      <SVGAssets.PricingArrow className="w-2.5 mr-2 text-black" />
      <div className="text-left">
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>
    </Button>
  );
};
